import type { CustomerContext } from '@techgitter/contracts';

const API_BASE_URL = '/api';

export async function fetchCustomerContext(
  dataverseCustomerId: string,
  signal?: AbortSignal,
): Promise<CustomerContext> {
  const response = await fetch(
    `${API_BASE_URL}/customers/${encodeURIComponent(dataverseCustomerId)}`,
    { method: 'GET', headers: { Accept: 'application/json' }, signal },
  );

  if (!response.ok) {
    throw new Error(
      `Failed to fetch customer context: ${response.status} ${response.statusText}`,
    );
  }

  return (await response.json()) as CustomerContext;
}
